module.exports = __webpack_public_path__ + "media/images/ic-pin-azul-4e7dbfb2a7c49c006d901823eb6fc2f2.png";